module.exports = __webpack_public_path__ + "static/media/isometry_background.575c19ea.jpg";